const TOKEN_KEY = 'admin_token';
const USER_KEY = 'admin_user';
const SESSION_COOKIE_KEY = 'admin_session_token';

const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

function getCookie(name) {
    if (!isBrowser) return null;

    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const target = `${name}=`;

    for (const cookie of cookies) {
        if (cookie.startsWith(target)) {
            return decodeURIComponent(cookie.substring(target.length));
        }
    }

    return null;
}

function setSessionCookie(name, value) {
    if (!isBrowser) return;

    const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; SameSite=Lax${secureAttr}`;
}

function clearCookie(name) {
    if (!isBrowser) return;

    const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${secureAttr}`;
}

function parseJSON(raw) {
    if (!raw) return null;

    try {
        return JSON.parse(raw);
    } catch (error) {
        return null;
    }
}

const authStorage = {
    getToken() {
        if (!isBrowser) return null;
        return localStorage.getItem(TOKEN_KEY) || getCookie(SESSION_COOKIE_KEY);
    },

    getCachedAdmin() {
        if (!isBrowser) return null;
        const remembered = parseJSON(localStorage.getItem(USER_KEY));
        if (remembered) return remembered;

        const sessionAdmin = parseJSON(sessionStorage.getItem(USER_KEY));
        return sessionAdmin;
    },

    saveAuth(token, admin, rememberMe = false) {
        if (!isBrowser) return;
        this.clearAuth();

        if (rememberMe) {
            localStorage.setItem(TOKEN_KEY, token);
            localStorage.setItem(USER_KEY, JSON.stringify(admin));
            return;
        }

        setSessionCookie(SESSION_COOKIE_KEY, token);
        sessionStorage.setItem(USER_KEY, JSON.stringify(admin));
    },

    updateCachedAdmin(admin) {
        if (!isBrowser || !admin) return;

        if (localStorage.getItem(TOKEN_KEY)) {
            localStorage.setItem(USER_KEY, JSON.stringify(admin));
            return;
        }

        if (getCookie(SESSION_COOKIE_KEY)) {
            sessionStorage.setItem(USER_KEY, JSON.stringify(admin));
        }
    },

    clearAuth() {
        if (!isBrowser) return;
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        sessionStorage.removeItem(USER_KEY);
        clearCookie(SESSION_COOKIE_KEY);
    }
};

export default authStorage;
